import { Link } from "react-router-dom";
import { ARTICLES } from "@/data/articles";
import { useSeo } from "@/lib/seo";
import { Badge } from "@/components/ui/badge";
import { BookOpen, ArrowRight, Clock } from "lucide-react";

export default function Blog() {
  useSeo({
    title: "Blog BTP — Guides pratiques planning de chantier | ChantiPlanning",
    description:
      "Guides pratiques et méthodes pour bien planifier un chantier BTP : chemin critique, corps d'état, méthodologie complète. Rédigés pour les pros.",
    canonicalPath: "/blog",
  });
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14" data-testid="blog-index">
      <div className="mb-10">
        <Badge className="bg-[#0F2137] text-white hover:bg-[#0F2137] font-mono-tech uppercase tracking-wider text-[11px]">
          <BookOpen className="w-3 h-3 mr-1.5" /> Ressources
        </Badge>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[#0F2137] mt-4">
          Blog planning de chantier
        </h1>
        <p className="text-slate-600 mt-3 text-base sm:text-lg max-w-2xl">
          Méthodes, checklists et concepts clés pour planifier un chantier BTP sans dérive. Écrit
          pour les chefs de projet, artisans et maîtres d'œuvre.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-5" data-testid="articles-grid">
        {ARTICLES.map((a) => (
          <Link
            to={`/blog/${a.slug}`}
            key={a.slug}
            data-testid={`article-card-${a.slug}`}
            className="group rounded-xl border border-slate-200 bg-white p-6 hover:border-[#F59E0B] transition-colors"
          >
            <div className="text-4xl mb-3">{a.heroEmoji}</div>
            <h2 className="font-display font-bold text-xl text-[#0F2137] leading-tight">
              {a.title}
            </h2>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-3">
              {a.description}
            </p>
            <div className="mt-4 flex items-center justify-between">
              <span className="font-mono-tech text-[10px] uppercase tracking-wider text-slate-500 inline-flex items-center gap-1">
                <Clock className="w-3 h-3" /> {a.readingMin} min de lecture
              </span>
              <span className="text-sm font-semibold text-[#B45309] inline-flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                Lire <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
